module.exports = __webpack_public_path__ + "media/images/gallery/2s-b3482d1ad2549d477c4bbc1f5821429c.jpg";